// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__3g3kP","menu":"Aside_menu__1bZt1","omniosLink":"Aside_omniosLink__MorGo"};